module.exports = __webpack_public_path__ + "static/media/6.11.b4dac9f8.png";